import { render, staticRenderFns } from "./AvatarUploadForm.vue?vue&type=template&id=21f66445&"
import script from "./AvatarUploadForm.vue?vue&type=script&lang=ts&"
export * from "./AvatarUploadForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports